export default __webpack_public_path__ + "static/media/overviewBannerDesktop.ed4ca3f4.png";